// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"style__infoIcon__2nx6d","optional1":"style__optional1__7eDj4","optional2":"style__optional2__ZBrf8"};